// extracted by css-extract-rspack-plugin
export default {"post-card-wrapper":"CbwwIw","postCardWrapper":"CbwwIw","post-card-link":"reHTMk","postCardLink":"reHTMk","post-card":"ti4I8j","postCard":"ti4I8j"};